var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.temPainel
    ? _c(
        "div",
        { staticClass: "painel-deliberacao ia-block-card" },
        [
          _c(
            "button",
            {
              staticClass:
                "ia-block-card__cabecalho ia-block-card__cabecalho--clicavel painel-deliberacao__topo",
              attrs: {
                type: "button",
                "aria-expanded": String(_vm.aberto),
                "aria-label": _vm.rotuloDoBotao
              },
              on: { click: _vm.alternar }
            },
            [
              _c("span", { staticClass: "painel-deliberacao__titulos" }, [
                _c("span", { staticClass: "az-ds-label" }, [
                  _vm._v(_vm._s(_vm.sobretitulo))
                ]),
                _c(
                  "span",
                  {
                    staticClass:
                      "ia-titulo-de-cartao painel-deliberacao__titulo"
                  },
                  [
                    _vm._v(" " + _vm._s(_vm.titulo) + " "),
                    _vm.salaAtiva
                      ? _c("span", {
                          staticClass: "iv2-dot-pulsante",
                          attrs: { "aria-hidden": "true" }
                        })
                      : _vm._e()
                  ]
                ),
                _c(
                  "span",
                  { staticClass: "painel-deliberacao__meta ia-texto-auxiliar" },
                  [
                    _vm.contadorAoVivo
                      ? _c(
                          "span",
                          {
                            staticClass: "painel-deliberacao__contador",
                            class: _vm.classeShimmer
                          },
                          [_vm._v(_vm._s(_vm.contadorAoVivo))]
                        )
                      : [_vm._v(_vm._s(_vm.metaDoCabecalho))],
                    _vm.custoAproximado
                      ? _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    var attrs = ref.attrs
                                    return [
                                      _c(
                                        "span",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              staticClass:
                                                "painel-deliberacao__aproximado"
                                            },
                                            "span",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [_vm._v("~")]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              2449323992
                            )
                          },
                          [
                            _c("span", [
                              _vm._v(
                                "Custo aproximado: alguma chamada não reportou o consumo de tokens."
                              )
                            ])
                          ]
                        )
                      : _vm._e()
                  ],
                  2
                )
              ]),
              _c("icon-svg", {
                staticClass: "ia-block-seta",
                class: _vm.classeSeta,
                attrs: {
                  name: "arrow-down-new-ux",
                  size: 14,
                  color: "var(--neutral-700)"
                }
              })
            ],
            1
          ),
          _c("v-expand-transition", [
            _vm.aberto
              ? _c("div", { staticClass: "painel-deliberacao__corpo" }, [
                  _c(
                    "div",
                    { staticClass: "painel-deliberacao__corpo-interno az-gap" },
                    [
                      _vm.orquestrador
                        ? _c("PainelOrquestrador", {
                            attrs: { orquestrador: _vm.orquestrador }
                          })
                        : _vm._e(),
                      _vm.divergencias.length
                        ? _c("PainelDivergencias", {
                            attrs: { divergencias: _vm.divergencias }
                          })
                        : _vm._e(),
                      _c(
                        "div",
                        {
                          staticClass:
                            "painel-deliberacao__deliberacao az-gap-small"
                        },
                        [
                          _c("div", { staticClass: "az-ds-label-sentenca" }, [
                            _vm._v(_vm._s(_vm.tituloDasRodadas))
                          ]),
                          _vm.encerramento
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "az-text-secondary az-size-12 az-muted"
                                },
                                [_vm._v(" " + _vm._s(_vm.encerramento) + " ")]
                              )
                            : _vm._e(),
                          _vm._l(_vm.rodadas, function(grupo) {
                            return _c(
                              "div",
                              {
                                key: grupo.rodada,
                                staticClass: "painel-deliberacao__rodada"
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "painel-deliberacao__rodada-topo",
                                    attrs: {
                                      type: "button",
                                      "aria-expanded": String(grupo.aberta),
                                      "aria-label": grupo.rotulo
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.alternarRodada(grupo)
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "painel-deliberacao__marcador ia-texto-selo"
                                      },
                                      [_vm._v(_vm._s(grupo.marcador))]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "az-text-primary az-size-12 painel-deliberacao__rodada-titulo"
                                      },
                                      [_vm._v(" " + _vm._s(grupo.titulo) + " ")]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "az-text-secondary az-size-12 az-muted painel-deliberacao__resumo"
                                      },
                                      [_vm._v(" " + _vm._s(grupo.resumo) + " ")]
                                    ),
                                    _c("icon-svg", {
                                      staticClass: "ia-block-seta",
                                      class: grupo.classeSeta,
                                      attrs: {
                                        name: "arrow-down-new-ux",
                                        size: 12,
                                        color: "var(--neutral-700)"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c("v-expand-transition", [
                                  grupo.aberta
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "painel-deliberacao__rodada-corpo"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "painel-deliberacao__rodada-conteudo az-gap-small"
                                            },
                                            [
                                              _vm._l(grupo.turnos, function(
                                                turno
                                              ) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: turno.chave,
                                                    staticClass:
                                                      "painel-deliberacao__turno az-gap-xsmall"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "d-flex align-center flex-wrap az-gap-small painel-deliberacao__cabecalho"
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "painel-avatar painel-avatar--pronto flex-shrink-0",
                                                            attrs: {
                                                              "aria-hidden":
                                                                "true"
                                                            }
                                                          },
                                                          [
                                                            _c("icon-svg", {
                                                              attrs: {
                                                                name:
                                                                  turno.icone,
                                                                size: 14,
                                                                color: "primary"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "az-text-primary az-size-12 font-medium"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                turno.label
                                                              )
                                                            )
                                                          ]
                                                        ),
                                                        turno.lead
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "painel-tag ia-texto-auxiliar"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.rotuloConduz
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        turno.enderecamento
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "az-text-secondary az-size-12 az-muted"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      turno.enderecamento
                                                                    ) +
                                                                    " "
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        turno.ehReplica
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "painel-tag ia-texto-auxiliar",
                                                                class:
                                                                  turno.classeDaPosicao
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    turno.posicao_label
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        turno.indisponivel
                                                          ? _c("BaseStatus", {
                                                              attrs: {
                                                                soft: "",
                                                                "preserve-case":
                                                                  "",
                                                                content:
                                                                  _vm.textoNaoRespondeu,
                                                                color:
                                                                  "warning-new"
                                                              }
                                                            })
                                                          : _vm._e()
                                                      ],
                                                      1
                                                    ),
                                                    turno.motivo_indisponivel
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "az-text-secondary az-size-12 az-muted painel-deliberacao__linha"
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  turno.motivo_indisponivel
                                                                ) +
                                                                " "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    turno.quote
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "painel-deliberacao__quote az-gap-xsmall"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "az-text-secondary az-size-12 az-muted"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    turno.quote
                                                                      .texto
                                                                  )
                                                                )
                                                              ]
                                                            ),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "az-text-secondary az-size-12 az-muted"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    turno.quote
                                                                      .atribuicao
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    turno.temFala
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "az-text-secondary az-size-12 painel-deliberacao__fala"
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  turno.fala
                                                                ) +
                                                                " "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    turno.estruturadoInline
                                                      ? _c(
                                                          "PainelTurnoDetalhes",
                                                          {
                                                            attrs: {
                                                              turno: turno
                                                            }
                                                          }
                                                        )
                                                      : _vm._e(),
                                                    turno.expansao.temConteudo
                                                      ? _c(
                                                          "button",
                                                          {
                                                            staticClass:
                                                              "az-ds-hyperlink painel-deliberacao__ver-analise ia-texto-auxiliar",
                                                            attrs: {
                                                              type: "button",
                                                              "aria-expanded": String(
                                                                Boolean(
                                                                  _vm
                                                                    .expandidos[
                                                                    turno.chave
                                                                  ]
                                                                )
                                                              ),
                                                              "aria-label":
                                                                _vm
                                                                  .rotulosDeExpansao[
                                                                  turno.chave
                                                                ] +
                                                                " de " +
                                                                turno.label
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.alternarTurno(
                                                                  turno.chave
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm
                                                                    .rotulosDeExpansao[
                                                                    turno.chave
                                                                  ]
                                                                )
                                                              )
                                                            ]),
                                                            _c("icon-svg", {
                                                              staticClass:
                                                                "ia-block-seta",
                                                              class: _vm
                                                                .expandidos[
                                                                turno.chave
                                                              ]
                                                                ? "ia-block-seta--aberta"
                                                                : "",
                                                              attrs: {
                                                                name:
                                                                  "arrow-down-new-ux",
                                                                size: 12,
                                                                color:
                                                                  "var(--primary)"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                    _c("v-expand-transition", [
                                                      _vm.expandidos[
                                                        turno.chave
                                                      ]
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "painel-deliberacao__analise az-gap-xsmall"
                                                            },
                                                            [
                                                              turno.temFala
                                                                ? _c(
                                                                    "PainelTurnoDetalhes",
                                                                    {
                                                                      attrs: {
                                                                        turno: turno
                                                                      }
                                                                    }
                                                                  )
                                                                : _vm._e(),
                                                              _vm._l(
                                                                turno.expansao
                                                                  .servicos,
                                                                function(
                                                                  servico
                                                                ) {
                                                                  return _c(
                                                                    "div",
                                                                    {
                                                                      key:
                                                                        servico.chave,
                                                                      staticClass:
                                                                        "az-text-secondary az-size-12"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            servico.codigo
                                                                          ) +
                                                                          " — " +
                                                                          _vm._s(
                                                                            servico.motivo
                                                                          ) +
                                                                          " "
                                                                      )
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                              _vm._l(
                                                                turno.expansao
                                                                  .perguntas,
                                                                function(
                                                                  pergunta
                                                                ) {
                                                                  return _c(
                                                                    "div",
                                                                    {
                                                                      key:
                                                                        pergunta.chave,
                                                                      staticClass:
                                                                        "az-text-secondary az-size-12 az-muted"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            pergunta.texto
                                                                          ) +
                                                                          " "
                                                                      )
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                              turno.expansao
                                                                .confianca
                                                                ? _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "az-text-secondary az-size-12 az-muted"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " Confiança " +
                                                                          _vm._s(
                                                                            turno
                                                                              .expansao
                                                                              .confianca
                                                                          ) +
                                                                          " — " +
                                                                          _vm._s(
                                                                            turno
                                                                              .expansao
                                                                              .confiancaPorque
                                                                          ) +
                                                                          " "
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e()
                                                            ],
                                                            2
                                                          )
                                                        : _vm._e()
                                                    ])
                                                  ],
                                                  1
                                                )
                                              }),
                                              _vm._l(
                                                _vm.cardsPorRodada[
                                                  grupo.rodada
                                                ],
                                                function(card) {
                                                  return _c("PainelCardVivo", {
                                                    key: card.chave,
                                                    attrs: { card: card }
                                                  })
                                                }
                                              )
                                            ],
                                            2
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ])
                              ],
                              1
                            )
                          })
                        ],
                        2
                      ),
                      _vm.emAndamento
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "d-flex align-center painel-deliberacao__cabecalho"
                            },
                            [
                              _c(
                                "output",
                                {
                                  staticClass:
                                    "az-text-secondary az-size-12 az-muted",
                                  class: _vm.classeShimmer,
                                  attrs: { "aria-live": "polite" }
                                },
                                [
                                  _vm._v(
                                    " O consultor está escrevendo a resposta a partir daqui. "
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ])
              : _vm._e()
          ])
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }